import { IOption } from 'components/forms/combobox/types'
import { IStoreState } from './base'

export interface ICustomer {
  id?: string
  name: string
  contacts: ICustomerContact[]
  notes?: string
  /**
   * Is this user imported via QuickBooks import
   */
  importedFromQuickbooks: boolean
}

export interface ICustomerContact {
  id?: number
  name: string | null
  email?: string
  phone?: string
  phoneExt?: string | null
  purpose: CUSTOMER_CONTACT_PURPOSE
  contactableId?: string
  contactableType?: string
  sourceContactId?: string
}

export enum CUSTOMER_CONTACT_PURPOSE {
  PRIMARY = 'customer_primary',
  ADDITIONAL = 'customer_additional',
  SHIPMENT = 'shipment_customer',
  FACILITY_PRIMARY = 'facility_primary',
  STOP_FACILITY = 'stop_facility',
  SUBSCRIBER = 'shipment_subscriber',
}

export interface ICustomersState extends IStoreState {
  customers: ICustomer[]
  customersAutocomplete: IOption[]
  currentCustomer?: ICustomer
  saving?: boolean
  savingError?: string
}

export interface IFetchCustomersResponse {
  customers: ICustomer[]
  totalCount: number
  hasNextPage: boolean
}

export interface ICreateNewCustomerResponse {
  customer: ICustomer
}
